module.exports = __webpack_public_path__ + "media/images/plans/plans-kaihikon-b5825d989f114c3402e9ef52de64e367.png";